const name = 'orders';

export const GET_ORDERS_LIST_REQUEST = `${name}/GET_ORDERS_LIST_REQUEST`;
export const GET_ORDERS_LIST_SUCCESS = `${name}/GET_ORDERS_LIST_SUCCESS`;
export const GET_ORDERS_LIST_FAILURE = `${name}/GET_ORDERS_LIST_FAILURE`;

export const GET_ORDERS_TABLE_CONFIGURATION_REQUEST = `${name}/GET_ORDERS_TABLE_CONFIGURATION_REQUEST`;
export const GET_ORDERS_TABLE_CONFIGURATION_SUCCESS = `${name}/GET_ORDERS_TABLE_CONFIGURATION_SUCCESS`;
export const GET_ORDERS_TABLE_CONFIGURATION_FAILURE = `${name}/GET_ORDERS_TABLE_CONFIGURATION_FAILURE`;

export const UPDATE_ORDERS_TABLE_ROW_REQUEST = `${name}/UPDATE_ORDERS_TABLE_ROW_REQUEST`;
export const UPDATE_ORDERS_TABLE_ROW_SUCCESS = `${name}/UPDATE_ORDERS_TABLE_ROW_SUCCESS`;
export const UPDATE_ORDERS_TABLE_ROW_FAILURE = `${name}/UPDATE_ORDERS_TABLE_ROW_FAILURE`;

export const GET_ORDERS_DETAILS_REQUEST = `${name}/GET_ORDERS_DETAILS_REQUEST`;
export const GET_ORDERS_DETAILS_SUCCESS = `${name}/GET_ORDERS_DETAILS_SUCCESS`;
export const GET_ORDERS_DETAILS_FAILURE = `${name}/GET_ORDERS_DETAILS_FAILURE`;

export const UPDATE_ORDER_DETAILS_REQUEST = `${name}/UPDATE_ORDER_DETAILS_REQUEST`;
export const UPDATE_ORDER_DETAILS_SUCCESS = `${name}/UPDATE_ORDER_DETAILS_SUCCESS`;
export const UPDATE_ORDER_DETAILS_FAILURE = `${name}/UPDATE_ORDER_DETAILS_FAILURE`;

export const DELETE_ORDER_DETAILS_REQUEST = `${name}/DELETE_ORDER_DETAILS_REQUEST`;
export const DELETE_ORDER_DETAILS_SUCCESS = `${name}/DELETE_ORDER_DETAILS_SUCCESS`;
export const DELETE_ORDER_DETAILS_FAILURE = `${name}/DELETE_ORDER_DETAILS_FAILURE`;

export const UPDATE_ORDER_STATUS_REQUEST = `${name}/UPDATE_ORDER_STATUS_REQUEST`;
export const UPDATE_ORDER_STATUS_SUCCESS = `${name}/UPDATE_ORDER_STATUS_SUCCESS`;
export const UPDATE_ORDER_STATUS_FAILURE = `${name}/UPDATE_ORDER_STATUS_FAILURE`;

export const GET_PRODUCT_VARIATIONS_DETAILS_REQUEST = `${name}/GET_PRODUCT_VARIATIONS_DETAILS_REQUEST`;
export const GET_PRODUCT_VARIATIONS_DETAILS_SUCCESS = `${name}/GET_PRODUCT_VARIATIONS_DETAILS_SUCCESS`;
export const GET_PRODUCT_VARIATIONS_DETAILS_FAILURE = `${name}/GET_PRODUCT_VARIATIONS_DETAILS_FAILURE`;

export const NOVAPOSHTA_TTN_CREATE_REQUEST = `${name}/NOVAPOSHTA_TTN_CREATE_REQUEST`;
export const NOVAPOSHTA_TTN_CREATE_SUCCESS = `${name}/NOVAPOSHTA_TTN_CREATE_SUCCESS`;
export const NOVAPOSHTA_TTN_CREATE_FAILURE = `${name}/NOVAPOSHTA_TTN_CREATE_FAILURE`;

export const UKRPOSHTA_TTN_CREATE_REQUEST = `${name}/UKRPOSHTA_TTN_CREATE_REQUEST`;
export const UKRPOSHTA_TTN_CREATE_SUCCESS = `${name}/UKRPOSHTA_TTN_CREATE_SUCCESS`;
export const UKRPOSHTA_TTN_CREATE_FAILURE = `${name}/UKRPOSHTA_TTN_CREATE_FAILURE`;

export default name;
